var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.8,5 C10.2910419,5 11.5439019,5.99145047 11.8991648,7.3332532 L20,7.33333333 L20,8.88888889 L11.8991648,8.88896902 C11.5439019,10.2307717 10.2910419,11.2222222 8.8,11.2222222 C7.30895814,11.2222222 6.0560981,10.2307717 5.7008352,8.88896902 L4,8.88888889 L4,7.33333333 L5.7008352,7.3332532 C6.0560981,5.99145047 7.30895814,5 8.8,5 Z M8.8,6.55555556 C7.9163444,6.55555556 7.2,7.2520015 7.2,8.11111111 C7.2,8.97022072 7.9163444,9.66666667 8.8,9.66666667 C9.6836556,9.66666667 10.4,8.97022072 10.4,8.11111111 C10.4,7.2520015 9.6836556,6.55555556 8.8,6.55555556 Z M15.2,12.7777778 C16.6910419,12.7777778 17.9439019,13.7692283 18.2991648,15.111031 L20,15.1111111 L20,16.6666667 L18.2991648,16.6667468 C17.9439019,18.0085495 16.6910419,19 15.2,19 C13.7089581,19 12.4560981,18.0085495 12.1008352,16.6667468 L4,16.6666667 L4,15.1111111 L12.1008352,15.111031 C12.4560981,13.7692283 13.7089581,12.7777778 15.2,12.7777778 Z M15.2,14.3333333 C14.3163444,14.3333333 13.6,15.0297793 13.6,15.8888889 C13.6,16.7479985 14.3163444,17.4444444 15.2,17.4444444 C16.0836556,17.4444444 16.8,16.7479985 16.8,15.8888889 C16.8,15.0297793 16.0836556,14.3333333 15.2,14.3333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#757574",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0dc38026f34f1fb9d47039f260ecbb83.svg";
export { ForwardRef as ReactComponent };